import { HpmsCustomCardEvent, HpmsCustomCardMenuRenderEvent, HPMSOnCreateOption, HPMSOnOptionClick } from '@philips-emr/hpms-components';
import { FieldAPI } from '@philips-emr/tws-components';
import Controller, { OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames, MensalidadesAliases } from '../../codegen';
import FilterService from '../../services/filter-service';

import BaseMensalidadeController, { Mensalidade } from './base-mensalidade-controller';

@Controller({ fragment: FragmentNames.MENSALIDADES })
export default class MensalidadesController extends BaseMensalidadeController {

  @OnMount(MensalidadesAliases.FILTER)
  onFilterMount = (event: MountEvent): void => FilterService.restoreFilterState(event);

  @OnMount(MensalidadesAliases.FIELD_NOTA_FISCAL)
  onFieldNFMount({ target }: MountEvent): void {
    const api = target as FieldAPI;
    const { nrNotaFiscal } = api.getData();

    if (!nrNotaFiscal) {
      api.setVisible(false);
    }

  }

  @OnUnmount(MensalidadesAliases.FILTER)
  onFilterUnmount = (event: MountEvent): void => FilterService.persistFilterState(event);

  @OnMount(MensalidadesAliases.FILTERED_LIST)
  onMountFetchMensalidades = (): void => super.onMountFetchMensalidades();

  @OnDynamicContentRender(MensalidadesAliases.CUSTOM_CARD_MENSALIDADES)
  onDynamicContentRender = (event: RenderEvent): void => super.onDynamicContentRender(event);

  @HPMSOnCreateOption(MensalidadesAliases.CUSTOM_CARD_MENSALIDADES)
  onCreateOption = (event: HpmsCustomCardMenuRenderEvent<Mensalidade>): void => super.onCreateOption(event);

  @HPMSOnOptionClick(MensalidadesAliases.CUSTOM_CARD_MENSALIDADES)
  onOptionClick = (event: HpmsCustomCardEvent<Mensalidade>): void => super.onOptionClick(event);
}
